module.exports = __webpack_public_path__ + "img/esyoil-rating.6688de4.svg";